import React, { memo } from 'react';
import { translate } from 'react-i18next';
import { Box, Text } from 'wix-style-react';
import s from './InputFullApp.scss';
var _SubjectLine = function (_a) {
    var t = _a.t, onSubjectChange = _a.onSubjectChange, subject = _a.subject;
    return (React.createElement(Box, { "data-hook": "input-subject-line-wrapper", width: "100%", align: "center", height: "34px", verticalAlign: "middle" },
        React.createElement(Box, { marginLeft: "2px", marginRight: "6px" },
            React.createElement(Text, { dataHook: "input-subject-label", light: true, secondary: true, size: "small" }, t('input.subject.label') + ":")),
        React.createElement("input", { "data-hook": "input-subject-line", onChange: onSubjectChange, value: subject, className: s.subjectLineInput })));
};
export var SubjectLine = memo(translate()(_SubjectLine), function (prev, next) { return prev.subject === next.subject; });
//# sourceMappingURL=SubjectLine.js.map